import { Component, OnInit } from '@angular/core';
import { TFMService } from 'app/mock-api/tfm.service';
import { Title, Meta } from '@angular/platform-browser';

import { ContactType02Component } from './contact-type02/contact-type02.component';
import { ContactType01Component } from './contact-type01/contact-type01.component';
import { ContactType03Component } from "./contact-type03/contact-type03.component";

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [ContactType01Component, ContactType02Component, ContactType03Component],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})

export class ContactComponent implements OnInit {

  public view: any = {

  }

  constructor(private _tfmService: TFMService, private title: Title, private metaService: Meta) {

  }

  ngOnInit(): void {
    this._tfmService.getSite().then(res => {
      this.view.site = res;

      if (this.view.site) {
        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        this._tfmService.log(this.view);
      }

    });

    this._tfmService.getContentBySection('contact').then(res => {
      this.view.page = res;

      if (this.view.page && this.view.site) {

        //Set title
        this.title.setTitle(this.view.page.content.name + " - " + this.view.site.name);

        // Set description & keywords
        this.metaService.updateTag( { name:'description', content:this.view.page.content.seo.description});
        this.metaService.updateTag( { name:'keywords', content:this.view.page.content.seo.keywords});
      }
    });
  }

}